import { useState, useEffect, useCallback } from 'react'
import ChatHead from '@components/chat/components/ChatHead'
import ListChats from '@components/chat/components/ListChats'
import ChatContacts from '@components/chat/components/Contacts'
import Icon from '@components/shared/Icon'

import useT from '@hooks/useTranslation'

const VIEWS = {
    USER_MESSAGES: 'user_mesages',
    SYSTEM_MESSAGES: 'system_messages',
    CONTACTS: 'contacts',
}

let lastViewConfig
const ChatList = ({ user, openChat, closeWindow }) => {
    const [contact, setContact] = useState(null)
    const [view, setView] = useState(lastViewConfig || {
        [VIEWS.USER_MESSAGES]: true,
        [VIEWS.SYSTEM_MESSAGES]: false,
        [VIEWS.CONTACTS]: false,
    })

    const listUserChats = view[VIEWS.USER_MESSAGES]
    const listSystemChats = view[VIEWS.SYSTEM_MESSAGES]
    const listContacts = view[VIEWS.CONTACTS]

    const openUserMessages = useCallback(() => setView({
            [VIEWS.USER_MESSAGES]: true,
            [VIEWS.SYSTEM_MESSAGES]: false,
            [VIEWS.CONTACTS]: listContacts,
    }), [view])

    const openSystemMessages = useCallback(() => setView({
        [VIEWS.USER_MESSAGES]: false,
        [VIEWS.SYSTEM_MESSAGES]: true,
        [VIEWS.CONTACTS]: listContacts,
    }), [view])

    const toggleContacts = useCallback(() => setView({
        ...view,
        [VIEWS.CONTACTS]: !listContacts,
    }), [view])

    const highlightContact = useCallback((contact) => {
        if (contact !== null) {
            setContact(contact)
            openUserMessages()
        } else {
            setContact(null)
        }
    }, [view])

    useEffect(() => {
        lastViewConfig = view
    }, [view])

    const text = {
        messages: useT('Wiadomości'),
        system: useT('Wiadomości systemowe'),
        contacts: useT('Kontakty'),
    }

    const actionsLeft = <>
        <ChatHead.Button text={text.messages} onClick={openUserMessages}
            active={listUserChats} />
        <ChatHead.Button text={text.system} onClick={openSystemMessages}
            active={listSystemChats} />
    </>

    const actionsRight = <>
        <ChatHead.Button text={text.contacts} onClick={toggleContacts}
            active={listContacts} />
    </>

    return <>
        <ChatHead
            icon={<Icon>mail_outline</Icon>}
            title={text.messages}
            onClose={closeWindow}
            actionsLeft={actionsLeft}
            actionsRight={actionsRight} />

        <ListChats
            user={user}
            openChat={openChat}
            highlightedContact={contact}
            listSystemChats={listSystemChats}
            listUserChats={listUserChats} />

        <ChatContacts
            isOpen={listContacts}
            user={user}
            currentContact={contact}
            highlightContact={highlightContact} />
    </>
}

export default ChatList